module.exports = __webpack_public_path__ + "img/e2e7650.svg";